// Pre-Vite FAQPage JSON-LD copied verbatim from the dulap-soft baseline
// snapshot (data/seo-snapshots/2026-06-05/pages/{root,ru}/page.html).
// Do not edit copy here without updating the baseline — Google compares
// answers across versions and rewriting them resets the rich-result trust.
export const FAQ_RO = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: 'Ce materiale folosiți și există garanție pentru produsele Dulap Studio?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Mobilierul nostru este realizat din PAL melaminat Egger – un material rezistent, elegant și ușor de întreținut, folosit pe scară largă în producția de mobilier premium european.',
      },
    },
    {
      '@type': 'Question',
      name: 'Aveți showroom?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Momentan nu avem showroom fizic, însă îți oferim o alternativă mai practică – poți comanda mostre gratuite de culori și texturi, pentru a le vedea și atinge înainte de a plasa comanda.\nAstfel, alegerea nu se face doar din poze, ci și din experiență reală.',
      },
    },
    {
      '@type': 'Question',
      name: 'În cât timp se execută o comandă?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Timpul de execuție este de 10–15 zile lucrătoare, în funcție de model și disponibilitatea materialelor.\nDupă confirmarea comenzii, îți trimitem actualizări despre stadiul producției și livrării.',
      },
    },
    {
      '@type': 'Question',
      name: 'Pot achita la livrare?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Da. Poți alege plata la livrare (numerar sau card bancar) sau plata online în momentul comenzii – integral sau parțial.',
      },
    },
    {
      '@type': 'Question',
      name: 'Livrați și montați mobila?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Da. Oferim livrare în raza municipiului Chișinău.\nMontarea poate fi efectuată de echipa noastră sau o poți face chiar tu: fiecare produs vine cu instrucțiuni clare, pas cu pas, și toate accesoriile incluse.',
      },
    },
    {
      '@type': 'Question',
      name: 'Pot comanda un dulap personalizat?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Absolut! Toate produsele Dulap Studio sunt personalizabile complet – poți alege dimensiunea, compartimentarea, culoarea, finisajul și tipul de mânere.\nFolosind configuratorul nostru 3D online, vezi în timp real designul final și prețul actualizat.',
      },
    },
    {
      '@type': 'Question',
      name: 'Cum pot comanda un produs?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Comanda se face direct pe site, în câțiva pași simpli: alegi produsul dorit, îl personalizezi în configuratorul 3D, completezi datele de contact și alegi metoda de plată.\nDupă plasarea comenzii, te contactăm pentru confirmare și detalii suplimentare.',
      },
    },
    {
      '@type': 'Question',
      name: 'Livrați și în afara Chișinăului sau în România?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Da. Livrăm în toată Republica Moldova, iar pentru comenzile în România oferim livrare prin curier, cu ambalare de siguranță adaptată transportului internațional.\nCostul livrării se calculează automat în funcție de localitate și greutate.',
      },
    },
    {
      '@type': 'Question',
      name: 'Pot returna produsul dacă nu se potrivește?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Da, poți returna produsul în termen de 30 zile calendaristice, dacă nu este ceea ce ți-ai dorit.\nÎți rambursăm suma achitată sau, dacă dorești, îți refacem produsul conform necesităților.',
      },
    },
    {
      '@type': 'Question',
      name: 'Oferiți asistență în alegerea designului?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Desigur. Echipa noastră te poate ajuta gratuit cu sfaturi de design și optimizare a spațiului, pentru ca mobilierul să se potrivească perfect casei tale.\nNe poți contacta pe chat, WhatsApp sau telefonic pentru consultanță personalizată.',
      },
    },
    {
      '@type': 'Question',
      name: 'Care sunt avantajele noastre?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Mobilă la comandă de orice nivel de complexitate — de la soluții compacte până la construcții încorporate;\nDesign modern — minimalism, scandinav, clasic, loft și alte stiluri;\nProducție în Moldova cu utilizarea feroneriei europene;\nNe puteți contacta prin chat, WhatsApp sau telefon pentru o consultație personalizată.',
      },
    },
    {
      '@type': 'Question',
      name: 'De ce să alegi Dulap Studio?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Dulap Studio este un serviciu online modern, unde poți comanda mobilă la comandă în Chișinău și în toată Moldova. Confecționăm dulapuri, comode, noptiere, comode TV și alt mobilier de corp, complet adaptat la dimensiunile spațiului tău și preferințele de design.\nFiecare proiect este elaborat ținând cont de configurația camerei și stilul interiorului. Designerii noștri te vor ajuta să alegi culoarea optimă. Creăm comode și mobilier pentru dormitor, living sau hol, care îmbină estetica și practicitatea.',
      },
    },
  ],
} as const

export const FAQ_RU = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: 'Какие материалы вы используете и есть ли гарантия на мебель Dulap Studio?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Наша мебель изготавливается из ламинированной плиты Egger (ЛДСП) – прочного, элегантного и лёгкого в уходе материала, широко используемого в производстве европейской мебели премиум-класса.',
      },
    },
    {
      '@type': 'Question',
      name: 'У вас есть шоурум?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Пока у нас нет физического шоурума, но мы предлагаем более удобную альтернативу – вы можете заказать бесплатные образцы цветов и текстур, чтобы увидеть и потрогать их до оформления заказа.\nТак выбор будет сделан не только по фотографиям, но и на основе личного впечатления.',
      },
    },
    {
      '@type': 'Question',
      name: 'Сколько времени занимает изготовление мебели?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Срок изготовления составляет 10–15 рабочих дней, в зависимости от модели и наличия материалов.\nПосле подтверждения заказа мы информируем вас о каждом этапе производства и доставки.',
      },
    },
    {
      '@type': 'Question',
      name: 'Можно ли оплатить при доставке?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Да. Вы можете оплатить заказ при доставке (наличными или банковской картой) либо онлайн — полностью или частично.',
      },
    },
    {
      '@type': 'Question',
      name: 'Вы доставляете и устанавливаете мебель?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Да. Мы осуществляем доставку в пределах муниципия Кишинев.\nСборку можно заказать у нашей команды или выполнить самостоятельно — каждая мебель поставляется с понятной пошаговой инструкцией и всеми необходимыми аксессуарами.',
      },
    },
    {
      '@type': 'Question',
      name: 'Можно ли заказать шкаф по индивидуальным размерам?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Конечно! Вся мебель Dulap Studio полностью настраивается — вы выбираете размеры, внутреннее наполнение, цвет, отделку и тип ручек.\nС помощью нашего 3D-конфигуратора вы можете в реальном времени увидеть итоговый дизайн и актуальную цену.',
      },
    },
    {
      '@type': 'Question',
      name: 'Как оформить заказ?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Заказ можно оформить прямо на сайте в несколько простых шагов: выберите нужный товар, настройте его в 3D-конфигураторе, заполните контактные данные и выберите способ оплаты.\nПосле оформления мы свяжемся с вами для подтверждения и уточнения деталей.',
      },
    },
    {
      '@type': 'Question',
      name: 'Вы доставляете за пределами Кишинева или в Румынию?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Да. Мы доставляем по всей территории Молдовы, а также выполняем доставку в Румынию через курьерские службы, с надёжной упаковкой для международной перевозки.\nСтоимость доставки рассчитывается автоматически в зависимости от населённого пункта и веса мебели.',
      },
    },
    {
      '@type': 'Question',
      name: 'Можно ли вернуть мебель, если она не подошла?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Да, вы можете вернуть мебель в течение 30 календарных дней, если она не соответствует вашим ожиданиям.\nМы вернём уплаченную сумму или, по вашему желанию, изготовим новую мебель в соответствии с вашими потребностями.',
      },
    },
    {
      '@type': 'Question',
      name: 'Помогаете ли вы с выбором дизайна?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Конечно. Наша команда бесплатно консультирует по вопросам дизайна и оптимизации пространства, чтобы мебель идеально подошла вашему дому.\nВы можете связаться с нами через чат, WhatsApp или по телефону для персональной консультации.',
      },
    },
    {
      '@type': 'Question',
      name: 'В чем наше преимущество?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Мебель под заказ любого уровня сложности — от компактных решений до встроенных конструкций;\nСовременный дизайн — минимализм, скандинавский, классический, loft и другие стили;\nПроизводство в Молдове с применением европейской фурнитуры;\nВы можете связаться с нами через чат, WhatsApp или по телефону для персональной консультации.',
      },
    },
    {
      '@type': 'Question',
      name: 'Почему стоит выбрать Dulap Studio?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Dulap Studio — это современный онлайн-сервис, где можно заказать мебель на заказ в Кишиневе и по всей Молдове. Мы изготавливаем шкафы, комоды, тумбочки, ТВ-тумбы и другую корпусную мебель, полностью адаптированную под размеры вашего пространства и пожелания по дизайну.\nКаждый проект разрабатывается с учетом планировки комнаты, стиля интерьера. Наши дизайнеры помогут подобрать оптимальный цвет. Мы создаем комоды и мебель для спальни, гостиной или прихожей, сочетающие эстетику и практичность.',
      },
    },
  ],
} as const
